import type { Signal } from "@suse-o11y/signal";
import { createContext } from "react";

import type { TimeRangeHistory } from "./time-range-history-utils";

export const TimeRangeHistoryContext = createContext<undefined | Signal<TimeRangeHistory>>(undefined);
